var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.25H4.5V4.5C4.5 3.12109 5.62109 2 7 2H15.9648C16.6289 2 17.2656 2.26172 17.7344 2.73047L18.7695 3.76562C19.2383 4.23438 19.5 4.87109 19.5 5.53516V8.25H18.25V5.53516C18.25 5.20312 18.1172 4.88672 17.8828 4.65234L16.8477 3.61719C16.6133 3.38281 16.2969 3.25 15.9648 3.25H7C6.30859 3.25 5.75 3.80859 5.75 4.5V8.25ZM19.5 10.75H4.5C3.80859 10.75 3.25 11.3086 3.25 12V17H4.5V15.75C4.5 15.0586 5.05859 14.5 5.75 14.5H18.25C18.9414 14.5 19.5 15.0586 19.5 15.75V17H20.75V12C20.75 11.3086 20.1914 10.75 19.5 10.75ZM19.5 18.25V20.75C19.5 21.4414 18.9414 22 18.25 22H5.75C5.05859 22 4.5 21.4414 4.5 20.75V18.25H3.25C2.55859 18.25 2 17.6914 2 17V12C2 10.6211 3.12109 9.5 4.5 9.5H19.5C20.8789 9.5 22 10.6211 22 12V17C22 17.6914 21.4414 18.25 20.75 18.25H19.5ZM5.75 15.75V20.75H18.25V15.75H5.75ZM18.875 11.6875C19.1236 11.6875 19.3621 11.7863 19.5379 11.9621C19.7137 12.1379 19.8125 12.3764 19.8125 12.625C19.8125 12.8736 19.7137 13.1121 19.5379 13.2879C19.3621 13.4637 19.1236 13.5625 18.875 13.5625C18.6264 13.5625 18.3879 13.4637 18.2121 13.2879C18.0363 13.1121 17.9375 12.8736 17.9375 12.625C17.9375 12.3764 18.0363 12.1379 18.2121 11.9621C18.3879 11.7863 18.6264 11.6875 18.875 11.6875Z",
    fill: "#040404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printerIcon.acb97e649bd811b0fafd5070d6dcdee1.svg";
export { ForwardRef as ReactComponent };